import { render } from "./Agents.vue?vue&type=template&id=72f06aca"
import script from "./Agents.vue?vue&type=script&lang=ts"
export * from "./Agents.vue?vue&type=script&lang=ts"
script.render = render

export default script